import { Directive, ElementRef, HostListener, inject } from '@angular/core';
import { MatRipple, RippleRef } from '@angular/material/core';

@Directive({
    selector: '[rippleOnHover]',
    providers: [MatRipple]
})
    
export class MatRippleDirective {
    private _elementRef = inject(ElementRef);
    private ripple = inject(MatRipple);

    rippleRef: RippleRef;
    @HostListener('mouseenter') onMouseEnter(): void {
        if (this._elementRef && this._elementRef.nativeElement) {
            this._elementRef.nativeElement.style.overflow = 'hidden';
        }
        
        if (this.ripple) {
            this.rippleRef = this.ripple.launch({ centered: true, persistent: true });
        }
    }
    @HostListener('mouseleave') onMouseLeave(): void {
        if (this.rippleRef) {
            this.rippleRef.fadeOut();
        }
    }
}